import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type IntegrationsSection } from '../../../WebsiteBuilder.types'

const websiteBuilderQueue = useBuilder('websiteBuilder')

export const IntegrationsCommands = {
  updateBlock: websiteBuilderQueue.createBlockCommand<IntegrationsSection>({
    commit: async (currentData, ctx) => merge(currentData, ctx.update),
  }),
}
